import React from 'react'

const TrendingPage = () => {
  return (
    <div>TrendingPage</div>
  )
}

export default TrendingPage